import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "@mui/material";

export default function StartSection() {

    const isMobile = useMediaQuery("(max-width:768px)");

    const titles = ["Adopt the Cloud Native Operational Model","Automate Software Delivery with Bridge LABS","Point & Click or Full Automation","API-Driven Operations with GitOps as a Service"];
      const descriptions =["The time has come to embrace Cloud Native operations. Stay ahead by optimizing your software delivery with modern DevOps & GitOps methodologies.",
                           "BridgeITOps, through its Bridge LABS product, provides startups with the best tools to automate software delivery seamlessly—making DevOps and GitOps the easiest part of your day.",
                           "For those who prefer a visual approach, Bridge LABS offers a centralized dashboard to manage multi-cloud provisioning, container orchestration, DevOps services, and IT team collaboration.",
                           "Everything you can do in the main dashboard, you can also achieve via GitOps as a Service API—giving you full programmatic control over your cloud infrastructure."];
      const [selected, setSelected] = useState(0);
      const [time, setTime] = useState(true);
      const { ref, inView } = useInView({threshold:0.5});
      useEffect(() => {
        const timeoutId= setTimeout(() => {
                    if(time && inView ){
                        setSelected(selected === 3 ? 0 : selected + 1);
                    }
                    }, 6000);
        return () => clearTimeout(timeoutId);
      }, [time,selected,Boolean(inView)]);
    return(
        isMobile ?
        <div ref={ref} className="px-8 z-10 relative flex flex-col gap-20 mt-[20vh] ">
            <h4 className="font-extrabold text-center text-stone-700 xs:text-[2rem] s:text-[2.25rem] ">Every  Company is A <span className="text-orange-600">Tech Company!</span></h4>
            <div className="flex flex-col w-full gap-6 ">
            <h6 className="font-bold xs:text-[1.25rem] s:text-[1.5rem] text-stone-700 ">{titles[selected]}</h6>
            <p className="font-medium w-full xs:text-[1.125rem] text-[1.375rem] text-stone-600 ">{descriptions[selected]}</p>
            <div className="flex  gap-3 transition-all duration-500 ease-in-out self-end mr-4">
                        {Array.from({length:4}).map((_,i)=>(
                            <motion.div key={i} onClick={()=>setSelected(i)} className={`w-5 cursor-pointer transition-all  duration-500  h-5 rounded-[4px] ${selected === i ? 'bg-orange-500' : 'bg-stone-300'}`}></motion.div>
                        ))}
            </div>
            </div>

        </div>
        :
        <div className="px-[10vw] flex items-center justify-between relative z-10" ref={ref}>
            <motion.h4 viewport={{ once: true }}  initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className="text-stone-700 font-extrabold text-[2.8125vw] ">Every <br></br> Company is <br></br> A  <span className="text-orange-600">Tech Company!</span></motion.h4>
            <motion.div viewport={{ once: true }}  initial={{opacity:0,x:50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className="flex flex-col justify-between h-[35.75vh] cursor-pointer" onMouseOver={()=>setTime(false)} onMouseOut={()=>setTime(true)} >
                <AnimatePresence mode="wait">
                <motion.div  key={selected} initial={{opacity:0}} whileInView={{opacity:1}} exit={{opacity:0 , transition : {duration:0.2}}}  transition={{type:"spring",duration:0.5 ,ease : 'easeIn'}} className=" flex flex-col gap-[2.963vh]" >
                <h6 className="font-bold text-[1.666vw] text-stone-700 ">{titles[selected]}</h6>
                <p className="font-medium text-[1.4583vw] text-stone-600 w-[42.1875vw]">{descriptions[selected]}</p>
                </motion.div>
                </AnimatePresence>
                <div className="px-[1.25vw] flex items-center justify-between" >
                   
                    <button  onClick={()=>{document.getElementById("contact").scrollIntoView({behavior: 'smooth',block: 'start' });}} className="rounded-[1.04vw] shadow-button hover:shadow-button-hover font-medium text-[1.25vw] text-white bg-stone-800 hover:bg-stone-950 py-[1.111vh] px-[2.9166vw] transition-all duration-500 ease-in-out">
                        LET'S START
                    </button>
                </div>
            </motion.div>
        </div>
    )
}